import { registerTelemetrySensitiveValue } from "./telemetry";
import { translate as t } from "./locale";

export interface StudentUser {
    accountType: "student";
    id: string;
    name: string;
    studentId: number;
}

export interface TeacherUser {
    accountType: "teacher";
    id: string;
    name: string;
    teacherId: number;
}

export interface AuthenticatedSession {
    authenticated: true;
    csrfToken: string;
    user: StudentUser | TeacherUser;
}

export interface AnonymousSession {
    authenticated: false;
}

export type Session = AnonymousSession | AuthenticatedSession;

export const authenticatedAccountLabel = (session: AuthenticatedSession): string =>
    session.user.accountType === "teacher" ?
        t("Zalogowany: Trener {name}", { name: session.user.name }) :
        t("Zalogowany: {name}", { name: session.user.name });

export const readSession = async (fetchImpl: typeof fetch = fetch): Promise<Session> => {
    const response = await fetchImpl("/api/auth/session", { credentials: "same-origin" });
    if (!response.ok) throw new Error("SESSION_READ_FAILED");
    const session = (await response.json()) as Session;
    if (session.authenticated) registerTelemetrySensitiveValue(session.user.name);
    return session;
};

export const csrfHeaders = (session: AuthenticatedSession): Record<string, string> => ({
    "X-CSRF-Token": session.csrfToken,
});
